
import { defineComponent } from '@vue/runtime-core'

const LoadingIconLarge = defineComponent({})
export default LoadingIconLarge
